import http from '../_http'

const partner = {
  //default
  summaryPartner : (m) => { return http.get(`manager/management/partner/summary`, m); },
  resetPartner : (m) => { return http.get(`manager/management/partner/reset/password/${m.id}`); }, //  cmd : mail.pw.reset
  listPartner : (m) => { return http.post(`manager/management/partner/list`, m); },
  detailPartner : (m) => { return http.get(`manager/management/partner/${m.id}`); },
  invitePartner : (m) => { return http.post(`manager/management/partner/invite`, m); },
  servicePartner : (m) => { return http.post(`manager/management/partner/service`, m); },

  //crud
  insertPartner : (m) => { return http.post(`manager/management/partner`, m); },
  updatePartner : (m) => { return http.put(`manager/management/partner`, m); },
  deletePartner : (m) => { return http.delete(`manager/management/partner/${m.id}`); },

  //ip reset
  ipPartner : (m) => { return http.get(`manager/management/partner/reset/ip/${m.id}`); },

  //credit
  creditPartner : (m) => { return http.get(`manager/management/partner/credit/${m.id}`); },

  //import partner site
  plusCredit : (m) => { return http.post(`manager/management/partner/creditplus`, m); },
  minusCredit : (m) => { return http.post(`manager/management/partner/creditminus`, m); },
}

export default partner

export { partner }